import { colors, fontSizes } from '../consts'
import { styled } from '@mui/system'

type QuestionProps = {
  uiTheme?: 'light' | 'dark'
}

type AnswerProps = {
  selected?: boolean
  uiTheme?: 'light' | 'dark'
  correct?: number
}

export const QuestionBox = styled('div')<QuestionProps>(({ uiTheme, theme }) => ({
  width: '40%',
  margin: theme.spacing(1),
  background: uiTheme === 'dark' ? colors.gray.gray90 : colors.lightestGrey,
  borderRadius: 12,
  padding: theme.spacing(3),
  height: '100%',
  position: 'relative',
  [theme.breakpoints.between('md', 'lg')]: {
    width: '60%',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: '70%',
    minHeight: 80,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    width: '100%',
    minHeight: 80,
  },
  '& .questionRow': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .titleCon': {
      display: 'flex',
      flexDirection: 'row',
      '& .icon': {
        height: 25,
        color: uiTheme === 'dark' ? colors.gray.gray40 : colors.gray.gray75,
      },
      '& .questionTextCon': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& .questionText': {
          fontSize: fontSizes.medium,
          color: uiTheme === 'dark' ? colors.white : colors.text,
          fontWeight: 800,
          margin: theme.spacing(0, 2),
          [theme.breakpoints.down('sm')]: {
            fontSize: fontSizes.small,
          },
        },
      },
    },
  },
  '& .navControlsCon': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    '& .navControl': {
      cursor: 'pointer',
      fontWeight: 800,
      fontSize: fontSizes.medium,
      color: uiTheme === 'dark' ? colors.gray.gray40 : colors.gray.gray75,
      margin: theme.spacing(2, 1),
    },
  },
}))

//CORRECT COLORS
//Correct - 2 (green)
//Incorrect - 1 (red)
//Not Graded Yet - 0 (either blue or grey based on if that answer choice is selected)
export const AnswerItem = styled('div')<AnswerProps>(
  ({ uiTheme, correct, selected, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: uiTheme === 'dark' ? colors.gray.gray80 : colors.offWhite,
    borderRadius: 20,
    border:
      correct === 2
        ? `solid 2px ${colors.green}`
        : correct === 1
        ? `solid 2px ${colors.red}`
        : selected
        ? `solid 2px ${colors.lightBlue}`
        : `solid 2px ${uiTheme === 'dark' ? colors.gray.gray75 : colors.lightestGrey}`,
    margin: theme.spacing(2, 1),
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
    minHeight: 40,
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      padding: theme.spacing(0, 2),
      minHeight: 25,
    },
    '& .answerCon': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& img': {
        margin: theme.spacing(0.5),
        width: 50,
        borderRadius: '10%',
        [theme.breakpoints.down('sm')]: {
          width: 40,
        },
      },
      '& .answerTextCon': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& .answerText': {
          fontSize: fontSizes.medium,
          color: uiTheme === 'dark' ? colors.white : colors.text,
          fontWeight: 500,
          margin: theme.spacing(0, 1),
          [theme.breakpoints.down('sm')]: {
            fontSize: fontSizes.small,
          },
        },
        '& .extraText': {
          fontSize: fontSizes.small,
          color: uiTheme === 'dark' ? colors.gray.gray40 : colors.gray.gray70,
          margin: theme.spacing(0, 1),
          fontWeight: 500,
          [theme.breakpoints.down('sm')]: {
            fontSize: fontSizes.xSmall,
          },
        },
      },
    },
  })
)

export const PercentCon = styled('p')<AnswerProps>(
  ({ uiTheme, correct, selected, theme }) => ({
    marginRight: 10,
    fontSize: fontSizes.medium,
    fontWeight: 700,
    color:
      correct === 2
        ? colors.green
        : correct === 1
        ? colors.red
        : selected
        ? colors.lightBlue
        : uiTheme === 'dark'
        ? colors.lightestGrey
        : colors.gray.gray70,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  })
)
